import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Menu, MenuItem, Typography } from '@mui/material';

import useInsuranceInfo from '../../../hooks/useInsuranceInfo';

import {
  StyledNavLinkDropdownContainer,
  StyledCaretIconContainer,
  StyledCaretIcon,
  StyledNavMenuItemDesktopLink,
} from './NavMenuDesktop.styled';

function NavLinkDropdown({ caption, linkItems }) {
  const history = useHistory();
  const { type: insuranceType } = useInsuranceInfo();

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const [hovering, setHovering] = useState(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <StyledNavLinkDropdownContainer>
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <StyledNavMenuItemDesktopLink
        component="button"
        variant="h3"
        aria-haspopup="true"
        id={`button_${caption}`}
        aria-controls={open ? `menu_${caption}` : undefined}
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        onMouseOver={() => setHovering(true)}
        onMouseOut={() => setHovering(false)}
      >
        {caption}
        <StyledCaretIconContainer>
          <StyledCaretIcon open={open} hovering={hovering} />
        </StyledCaretIconContainer>
      </StyledNavMenuItemDesktopLink>

      <Menu
        id={`menu_${caption}`}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          list: {
            'aria-labelledby': `button_${caption}`,
          },
        }}
      >
        {linkItems.map((item) => {
          const { link, text, icon, externalUrl, displayForInsuranceTypes } = item;

          if (
            Array.isArray(displayForInsuranceTypes) &&
            !displayForInsuranceTypes.includes(insuranceType)
          )
            return null;

          return (
            <MenuItem
              key={link}
              aria-label={text}
              onClick={() => {
                handleClose();

                if (externalUrl) {
                  window.open(link, '_blank');
                } else {
                  history.push(link);
                }
              }}
            >
              <div>
                <img src={icon} alt={text} />
                <Typography variant="p">{text}</Typography>
              </div>
            </MenuItem>
          );
        })}
      </Menu>
    </StyledNavLinkDropdownContainer>
  );
}

export default NavLinkDropdown;

NavLinkDropdown.propTypes = {
  caption: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  linkItems: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.string,
      text: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
      icon: PropTypes.string,
      externalUrl: PropTypes.bool,
      displayForInsuranceTypes: PropTypes.arrayOf(PropTypes.string),
    })
  ),
};
